module.exports = __webpack_public_path__ + "img/preview-2.d05e634b.png";